// Taken from the languages Prism.js supports, and their naming for them.
export const codeLangNames: Record<string, string> = {
  "markup": "Markup",
  "css": "CSS",
  "c-like": "C-like",
  "javascript": "JavaScript",
  "abap": "ABAP",
  "abnf": "ABNF",
  "actionscript": "ActionScript",
  "ada": "Ada",
  "agda": "Agda",
  "al": "AL",
  "antlr4": "ANTLR4",
  "apache-configuration": "Apache Configuration",
  "apex": "Apex",
  "apl": "APL",
  "applescript": "AppleScript",
  "aql": "AQL",
  "arduino": "Arduino",
  "arff": "ARFF",
  "arm-assembly": "ARM Assembly",
  "arturo": "Arturo",
  "asciidoc": "AsciiDoc",
  "asp-net": "ASP.NET (C#)",
  "6502-assembly": "6502 Assembly",
  "atmel-avr-assembly": "Atmel AVR Assembly",
  "autohotkey": "AutoHotkey",
  "autoit": "AutoIt",
  "avisynth": "AviSynth",
  "avro-idl": "Avro IDL",
  "awk": "AWK",
  "bash": "Bash",
  "basic": "BASIC",
  "batch": "Batch",
  "bbcode": "BBcode",
  "bbj": "BBj",
  "bicep": "Bicep",
  "birb": "Birb",
  "bison": "Bison",
  "bnf": "BNF",
  "bqn": "BQN",
  "brainfuck": "Brainfuck",
  "brightscript": "BrightScript",
  "bro": "Bro",
  "bsl": "BSL (1C:Enterprise)",
  "c": "C",
  "c-sharp": "C#",
  "c-plusplus": "C++",
  "cfscript": "CFScript",
  "chaiscript": "ChaiScript",
  "cil": "CIL",
  "cilk-c": "Cilk/C",
  "cilk-c-plusplus": "Cilk/C++",
  "clojure": "Clojure",
  "cmake": "CMake",
  "cobol": "COBOL",
  "coffeescript": "CoffeeScript",
  "concurnas": "Concurnas",
  "content-security-policy": "Content-Security-Policy",
  "cooklang": "Cooklang",
  "coq": "Coq",
  "crystal": "Crystal",
  "css-extras": "CSS Extras",
  "csv": "CSV",
  "cue": "CUE",
  "cypher": "Cypher",
  "d": "D",
  "dart": "Dart",
  "dataweave": "DataWeave",
  "dax": "DAX",
  "dhall": "Dhall",
  "diff": "Diff",
  "django-jinja2": "Django/Jinja2",
  "dns-zone-file": "DNS zone file",
  "docker": "Docker",
  "dot": "DOT (Graphviz)",
  "ebnf": "EBNF",
  "editorconfig": "EditorConfig",
  "eiffel": "Eiffel",
  "ejs": "EJS",
  "elixir": "Elixir",
  "elm": "Elm",
  "embedded-lua-templating": "Embedded Lua templating",
  "erb": "ERB",
  "erlang": "Erlang",
  "excel-formula": "Excel Formula",
  "f-sharp": "F#",
  "factor": "Factor",
  "false": "False",
  "firestore-security-rules": "Firestore security rules",
  "flow": "Flow",
  "fortran": "Fortran",
  "freemarker-template-language": "FreeMarker Template Language",
  "gamemaker-language": "GameMaker Language",
  "gap": "GAP (CAS)",
  "g-code": "G-code",
  "gdscript": "GDScript",
  "gedcom": "GEDCOM",
  "gettext": "gettext",
  "gherkin": "Gherkin",
  "git": "Git",
  "glsl": "GLSL",
  "gn": "GN",
  "gnu-linker-script": "GNU Linker Script",
  "go": "Go",
  "go-module": "Go module",
  "gradle": "Gradle",
  "graphql": "GraphQL",
  "groovy": "Groovy",
  "haml": "Haml",
  "handlebars": "Handlebars",
  "haskell": "Haskell",
  "haxe": "Haxe",
  "hcl": "HCL",
  "hlsl": "HLSL",
  "hoon": "Hoon",
  "http": "HTTP",
  "http-public-key-pins": "HTTP Public-Key-Pins",
  "http-strict-transport-security": "HTTP Strict-Transport-Security",
  "ichigojam": "IchigoJam",
  "icon": "Icon",
  "icu-message-format": "ICU Message Format",
  "idris": "Idris",
  "ignore": ".ignore",
  "inform-7": "Inform 7",
  "ini": "Ini",
  "io": "Io",
  "j": "J",
  "java": "Java",
  "javadoc": "JavaDoc",
  "javadoc-like": "JavaDoc-like",
  "java-stack-trace": "Java stack trace",
  "jexl": "Jexl",
  "jolie": "Jolie",
  "jq": "JQ",
  "jsdoc": "JSDoc",
  "js-extras": "JS Extras",
  "json": "JSON",
  "json5": "JSON5",
  "jsonp": "JSONP",
  "js-stack-trace": "JS stack trace",
  "js-templates": "JS Templates",
  "julia": "Julia",
  "keepalived-configure": "Keepalived Configure",
  "keyman": "Keyman",
  "kotlin": "Kotlin",
  "kumir": "KuMir (КуМир)",
  "kusto": "Kusto",
  "latex": "LaTeX",
  "latte": "Latte",
  "less": "Less",
  "lilypond": "LilyPond",
  "liquid": "Liquid",
  "lisp": "Lisp",
  "livescript": "LiveScript",
  "llvm-ir": "LLVM IR",
  "log-file": "Log file",
  "lolcode": "LOLCODE",
  "lua": "Lua",
  "magma": "Magma (CAS)",
  "makefile": "Makefile",
  "markdown": "Markdown",
  "markup-templating": "Markup templating",
  "mata": "Mata",
  "matlab": "MATLAB",
  "maxscript": "MAXScript",
  "mel": "MEL",
  "mermaid": "Mermaid",
  "metafont": "METAFONT",
  "mizar": "Mizar",
  "mongodb": "MongoDB",
  "monkey": "Monkey",
  "moonscript": "MoonScript",
  "n1ql": "N1QL",
  "n4js": "N4JS",
  "nand-to-tetris-hdl": "Nand To Tetris HDL",
  "naninovel-script": "Naninovel Script",
  "nasm": "NASM",
  "neon": "NEON",
  "nevod": "Nevod",
  "nginx": "nginx",
  "nim": "Nim",
  "nix": "Nix",
  "nsis": "NSIS",
  "objective-c": "Objective-C",
  "ocaml": "OCaml",
  "odin": "Odin",
  "opencl": "OpenCL",
  "openqasm": "OpenQasm",
  "oz": "Oz",
  "pari-gp": "PARI/GP",
  "parser": "Parser",
  "pascal": "Pascal",
  "pascaligo": "Pascaligo",
  "patrol-scripting-language": "PATROL Scripting Language",
  "pc-axis": "PC-Axis",
  "peoplecode": "PeopleCode",
  "perl": "Perl",
  "php": "PHP",
  "phpdoc": "PHPDoc",
  "php-extras": "PHP Extras",
  "plantuml": "PlantUML",
  "pl-sql": "PL/SQL",
  "powerquery": "PowerQuery",
  "powershell": "PowerShell",
  "processing": "Processing",
  "prolog": "Prolog",
  "promql": "PromQL",
  "properties": ".properties",
  "protocol-buffers": "Protocol Buffers",
  "pug": "Pug",
  "puppet": "Puppet",
  "pure": "Pure",
  "purebasic": "PureBasic",
  "purescript": "PureScript",
  "python": "Python",
  "q-sharp": "Q#",
  "q": "Q (kdb+ database)",
  "qml": "QML",
  "qore": "Qore",
  "r": "R",
  "racket": "Racket",
  "razor-c-sharp": "Razor C#",
  "react-jsx": "React JSX",
  "react-tsx": "React TSX",
  "reason": "Reason",
  "regex": "Regex",
  "rego": "Rego",
  "ren-py": "Ren'py",
  "rescript": "ReScript",
  "rest": "reST (reStructuredText)",
  "rip": "Rip",
  "roboconf": "Roboconf",
  "robot-framework": "Robot Framework",
  "ruby": "Ruby",
  "rust": "Rust",
  "sas": "SAS",
  "sass": "Sass (Sass)",
  "scss": "Sass (SCSS)",
  "scala": "Scala",
  "scheme": "Scheme",
  "shell-session": "Shell session",
  "smali": "Smali",
  "smalltalk": "Smalltalk",
  "smarty": "Smarty",
  "sml": "SML",
  "solidity": "Solidity (Ethereum)",
  "solution-file": "Solution file",
  "soy": "Soy (Closure Template)",
  "sparql": "SPARQL",
  "splunk-spl": "Splunk SPL",
  "sqf:-status-quo-function": "SQF: Status Quo Function (Arma 3)",
  "sql": "SQL",
  "squirrel": "Squirrel",
  "stan": "Stan",
  "stata-ado": "Stata Ado",
  "structured-text": "Structured Text (IEC 61131-3)",
  "stylus": "Stylus",
  "supercollider": "SuperCollider",
  "swift": "Swift",
  "systemd-configuration-file": "Systemd configuration file",
  "t4-templating": "T4 templating",
  "t4-c-sharp-templates": "T4 Text Templates (C#)",
  "t4-vb-templates": "T4 Text Templates (VB)",
  "tap": "TAP",
  "tcl": "Tcl",
  "template-toolkit-2": "Template Toolkit 2",
  "textile": "Textile",
  "toml": "TOML",
  "tremor": "Tremor",
  "turtle": "Turtle",
  "twig": "Twig",
  "typescript": "TypeScript",
  "typoscript": "TypoScript",
  "unrealscript": "UnrealScript",
  "uo-razor-script": "UO Razor Script",
  "uri": "URI",
  "v": "V",
  "vala": "Vala",
  "vb-net": "VB.Net",
  "velocity": "Velocity",
  "verilog": "Verilog",
  "vhdl": "VHDL",
  "vim": "vim",
  "visual-basic": "Visual Basic",
  "warpscript": "WarpScript",
  "webassembly": "WebAssembly",
  "web-idl": "Web IDL",
  "wgsl": "WGSL",
  "wiki-markup": "Wiki markup",
  "wolfram-language": "Wolfram language",
  "wren": "Wren",
  "xeora": "Xeora",
  "xml-doc": "XML doc (.net)",
  "xojo": "Xojo (REALbasic)",
  "xquery": "XQuery",
  "yaml": "YAML",
  "yang": "YANG",
  "zig": "Zig"
};
